import React, { useEffect, useState , useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ImageViewer from "react-simple-image-viewer";

import { AddIcon, EditIcon } from "@chakra-ui/icons";
import {
	Box,
	Button,
	Stack,
	useDisclosure,
	Table,
	Tbody,
	Text,
	Th,
	Thead,
	Tr,
	FormControl,
	Input,
	Select,
	Grid,
	GridItem,
	Card,
	CardHeader,
	CardBody,
	Icon,
	Flex,
	WrapItem,
	Wrap,
	Image,
	Checkbox,
	useToast,
	Tooltip,
	Divider,
	IconButton,
	Badge,
	Textarea,
	VStack,
	HStack,
	useColorModeValue,
	SimpleGrid,
	Alert,
	AlertIcon,
	AlertTitle,
	AlertDescription,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
} from "@chakra-ui/react";
import moment from "moment";
import {
	FiCalendar,
	FiFileText,
	FiCreditCard,
	FiUser,
	FiUpload,
	FiInfo,
	FiCheckCircle,
	FiGlobe,
	FiEdit3,
	FiSettings,
	FiZap,
	FiThermometer,
	FiCamera,
	FiHash,
} from "react-icons/fi";
import { IoReceiptOutline } from "react-icons/io5";
import { LuDroplets } from "react-icons/lu";
import { TbHistory } from "react-icons/tb";

import {
	MODAL_GRID_SPACING,
	MODAL_SECTION_SPACING,
	ModalFieldLabel,
	ModalFooterActions,
	PropertyModalSection,
	PropertyModalShell,
} from "./shared";

import { addUtilityPaymentAsync, markMultiplePaymentsAsPaidAsync, requestMeterPictureAsync, updateMeterInformationAsync } from "../../redux/user/userSlice";
import { API } from "../../utils/http";
import { fullDateFormat, fullDateTimeFormat } from "../../utils/types";
import { getPaymentStatus, getPaymentStatusColor, getRequestPeriodBadge } from "../../utils/utils";
import { makrMultiplePAymentsAsPaidVerifier, getPropertyAddress, addUtilityMeterVerifier } from "../../utils/verifier";
import Dropzone from "../Dropzone/Dropzone";
import InvoicesRow from "../TableRows/InvoicesRow";
import UtilityMeterTableRow from "../TableRows/UtilityMeterTableRow";

function _arrayBufferToBase64(buffer) {
	var binary = "";
	var bytes = new Uint8Array(buffer);
	var len = bytes.byteLength;
	for (var i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return window.btoa(binary);
}
export default function UtilityTab({ property }) {
	const isArchived = property.archived;
	const { t } = useTranslation();

	// Color mode variables
	const borderColor = useColorModeValue("gray.200", "gray.700");
	const iconColor = useColorModeValue("blue.500", "blue.300");

	// const loading = useSelector((state) => state.user.status) === "loading";
	const [loading, setLoading] = useState(false);
	const initialMeterInformation = { propertyId: property.id, meterType: "", meterIndex: "" };
	const initialEditMeterInformation = { propertyId: property.id, meterType: "", meter: { requestPeriod: {} } };
	const initialUtilityInvoiceInformation = {
		propertyId: property.id,
		utilityType: "",
		dueDate: "",
		amount: "",
		currency: "ron",
		invoice: { invoiceData: "", contentType: "", documentName: "" },
	};
	const initialRequestMeterPictureInformation = {
		gas: false,
		water: false,
		electricity: false,
	};
	const [availableUtilitiesInformation, setAvailableUtilitiesInformation] = useState(property.utilities.availableUtilities);
	const [utilityInvoiceInformation, setUtilityInvoiceInformation] = useState(initialUtilityInvoiceInformation);
	const [meterInformation, setMeterInformation] = useState(initialMeterInformation);
	const [requestMeterPictureInformation, setRequestMeterPictureInformation] = useState(initialRequestMeterPictureInformation);
	const [editMeterInformation, setEditMeterInformation] = useState(initialEditMeterInformation);
	const { isOpen: isMeterOpen, onOpen: onMeterOpen, onClose: onMeterClose } = useDisclosure();
	const { isOpen: isInvoiceOpen, onOpen: onInvoiceOpen, onClose: onInvoiceClose } = useDisclosure();
	const { isOpen: isHistoryOpen, onOpen: onHistoryOpen, onClose: onHistoryClose } = useDisclosure();
	const { isOpen: isRequestMeterOpen, onOpen: onRequestMeterOpen, onClose: onRequestMeterClose } = useDisclosure();
	const { isOpen: isEditMeterOpen, onOpen: onEditMeterOpen, onClose: onEditMeterClose } = useDisclosure();
	const [currentImage, setCurrentImage] = useState(0);
	const [isViewerOpen, setIsViewerOpen] = useState(false);
	const [images, setImages] = useState([]);
	const [query, setquery] = useState("");
	const utilityPayments = property.payments
		.filter((payment) => payment.type.toLowerCase().includes("utility"))
		.filter((payment) => {
			return (
				payment.type.toLowerCase().includes(query.toLowerCase()) ||
				payment.amount.toLowerCase().includes(query.toLowerCase()) ||
				payment.paymentMethod.toLowerCase().includes(query.toLowerCase())
			);
		});
	const [error, setError] = useState({});
	const toast = useToast();
	const handleSearchChange = (e) => {
		setquery(e.target.value);
	};
	const openImageViewer = useCallback((index) => {
		setCurrentImage(index);
		setIsViewerOpen(true);
	}, []);
	const closeImageViewer = () => {
		setCurrentImage(0);
		setIsViewerOpen(false);
	};
	const handleRequestMeterPictureChange = (e) => {
		setRequestMeterPictureInformation({ ...requestMeterPictureInformation, [e.target.name]: e.target.checked });
	};
	const handleChangeCheckboxes = (e) => {
		setAvailableUtilitiesInformation({ ...availableUtilitiesInformation, [e.target.name]: e.target.checked });
	};
	const saveCheckboxes = () => {
		const payload = { propertyId: property.id, availableUtilities: availableUtilitiesInformation };
		console.log(payload);
		dispatch(updateMeterInformationAsync(payload))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Update successful",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {});
	};
	useEffect(() => {
		console.log("Getting meter pictures urls");
		const payload = { propertyId: property.id, media: property.utilities.meterPictureHistory };
		API.put("get-meter-picture-urls", payload).then((r) => {
			setImages(r.data.media);
		});
	}, [property.utilities.meterPictureHistory, property.id]);
	const dispatch = useDispatch();
	const saveMeterInformation = () => {
		console.log(editMeterInformation);

		dispatch(updateMeterInformationAsync(editMeterInformation))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Update successful",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				onEditMeterClose();
				setEditMeterInformation(initialEditMeterInformation);
			});
	};
	const addUtilityMeter = () => {
		setLoading(true);
		console.log("added meter");
		console.log(meterInformation);
		const errors = addUtilityMeterVerifier(meterInformation);
		if (Object.entries(errors).length !== 0) {
			setError(errors);
			toast({
				title: "Error encountered.",
				description: "Invalid information",
				status: "error",
				duration: 2000,
				isClosable: true,
			});
			return;
		}
		setError({});
		//TODO: add meter info to database
		dispatch(updateMeterInformationAsync(meterInformation))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Update successful",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				onMeterClose();
				setMeterInformation(initialMeterInformation);
				setLoading(false);
			});
	};
	const addUtilityInvoice = () => {
		setLoading(true);
		console.log("add utility invoice");
		//TODO: call api and dispatch
		console.log(utilityInvoiceInformation);
		const errors = addUtilityMeterVerifier(utilityInvoiceInformation);
		if (Object.entries(errors).length !== 0) {
			setError(errors);
			toast({
				title: "Error encountered.",
				description: "Invalid information",
				status: "error",
				duration: 2000,
				isClosable: true,
			});
			return;
		}
		setError({});
		dispatch(addUtilityPaymentAsync(utilityInvoiceInformation))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Invoice Added!",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				onInvoiceClose();
				setUtilityInvoiceInformation(initialUtilityInvoiceInformation);
				setLoading(false);
			});
	};

	const { isOpen: isMarkMultiplePaymentsAsPaidOpen, onOpen: onMarkMultiplePaymentsAsPaidOpen, onClose: onMarkMultiplePaymentsAsPaidClose } = useDisclosure();
	const initialMultiplePaymentsAsPaidInformation = {
		payments: [],
		document: {},
		paymentDate: moment().format("yyyy-MM-DD"),
		documentNumber: "",
		paymentMethod: "op",
		billedTo: {},
	};
	const [markMultiplePaymentsAsPaidInformation, setMarkMultiplePaymentsAsPaidInformation] = useState(initialMultiplePaymentsAsPaidInformation);
	const handleBilledToChange = (e) => {
		const billedToEmail = e.target.value;
		console.log("email: ", billedToEmail);
		if (property.owner.email === billedToEmail) {
			setMarkMultiplePaymentsAsPaidInformation({
				...markMultiplePaymentsAsPaidInformation,
				billedTo: { name: property.owner.name, email: billedToEmail, type: "owner" },
			});
			return;
		}
		if (property.contacts.find((c) => c.email === billedToEmail)) {
			const contact = property.contacts.find((c) => c.email === billedToEmail);
			console.log(contact);
			setMarkMultiplePaymentsAsPaidInformation({
				...markMultiplePaymentsAsPaidInformation,
				billedTo: { name: contact.name, email: billedToEmail, type: contact.contactType },
			});
			return;
		}
		if (property.leaseContacts.find((c) => c.id === billedToEmail)) {
			const contact = property.leaseContacts.find((c) => c.id === billedToEmail);
			console.log(contact);
			setMarkMultiplePaymentsAsPaidInformation({
				...markMultiplePaymentsAsPaidInformation,
				billedTo: { name: contact.name, email: billedToEmail, type: contact.contactType },
			});
			return;
		}
		if (property.tenants.find((c) => c.email === billedToEmail)) {
			const tenant = property.tenants.find((c) => c.email === billedToEmail);
			console.log(tenant);
			setMarkMultiplePaymentsAsPaidInformation({
				...markMultiplePaymentsAsPaidInformation,
				billedTo: { name: tenant.name, email: billedToEmail, type: "tenant" },
			});
			return;
		}
	};
	const handleMarkMultiplePaymentsAsPaidChange = (e) => {
		console.log(e.target.value);
		if (e.target.checked) {
			setMarkMultiplePaymentsAsPaidInformation({
				...markMultiplePaymentsAsPaidInformation,
				payments: [...markMultiplePaymentsAsPaidInformation.payments, e.target.value],
			});
		} else {
			setMarkMultiplePaymentsAsPaidInformation({
				...markMultiplePaymentsAsPaidInformation,
				payments: markMultiplePaymentsAsPaidInformation.payments.filter((item) => item !== e.target.value),
			});
		}
	};
	const handleChangeMarkMultiplePaymentsAsPaidInformation = (e) => {
		setMarkMultiplePaymentsAsPaidInformation({ ...markMultiplePaymentsAsPaidInformation, [e.target.name]: e.target.value });
	};
	const onDocumentDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const name = acceptedFiles[0].name;
		const contentType = acceptedFiles[0].type;
		const document = { documentData: _arrayBufferToBase64(buffer), documentName: name, contentType };
		setMarkMultiplePaymentsAsPaidInformation({ ...markMultiplePaymentsAsPaidInformation, document });
	};
	const markMultiplePaymentsAsPaid = () => {
		setLoading(true);
		console.log("mark multiple payments as paid");
		const payload = {
			propertyId: property.id,
			...markMultiplePaymentsAsPaidInformation,
		};
		console.log(payload);
		const errors = makrMultiplePAymentsAsPaidVerifier(markMultiplePaymentsAsPaidInformation);
		console.log(errors);
		if (Object.entries(errors).length !== 0) {
			setError(errors);
			toast({
				title: "Error encountered.",
				description: "Invalid information",
				status: "error",
				duration: 2000,
				isClosable: true,
			});
			return;
		}
		setError({});
		dispatch(markMultiplePaymentsAsPaidAsync(payload))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Update successful",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				onMarkMultiplePaymentsAsPaidClose();
				setMarkMultiplePaymentsAsPaidInformation(initialMultiplePaymentsAsPaidInformation);
				setLoading(false);
			});
	};
	const handleCloseMarkMultiplePaymentsAsPaid = () => {
		onMarkMultiplePaymentsAsPaidClose();
		setMarkMultiplePaymentsAsPaidInformation(initialMultiplePaymentsAsPaidInformation);
		setError({});
	};
	const markMultiplePaymentsAsPaidModal = () => (
		<PropertyModalShell
			isOpen={isMarkMultiplePaymentsAsPaidOpen}
			onClose={handleCloseMarkMultiplePaymentsAsPaid}
			size="5xl"
			icon={FiCheckCircle}
			title={t("property.markMultipleAsPaid")}
			subtitle={t("property.markMultipleAsPaidSubtitle")}
			footer={
				<ModalFooterActions
					isLoading={loading}
					onCancel={handleCloseMarkMultiplePaymentsAsPaid}
					onConfirm={markMultiplePaymentsAsPaid}
					confirmLabel={t("table.markAsPaid")}
				/>
			}
		>
			<SimpleGrid columns={{ base: 1, lg: 2 }} spacing={MODAL_GRID_SPACING}>
				<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
					<PropertyModalSection icon={FiCalendar} title={t("property.paymentDetails")}>
						<VStack spacing={3} align="stretch">
							<SimpleGrid columns={2} spacing={4} w="full">
								<FormControl>
									<ModalFieldLabel icon={FiCalendar}>{t("property.paymentDate")}</ModalFieldLabel>
									<Input
										size="sm"
										type="date"
										name="paymentDate"
										value={markMultiplePaymentsAsPaidInformation.paymentDate}
										onChange={handleChangeMarkMultiplePaymentsAsPaidInformation}
										borderRadius="md"
									/>
								</FormControl>
								<FormControl>
									<ModalFieldLabel icon={FiFileText}>{t("property.documentNumber")}</ModalFieldLabel>
									<Input
										size="sm"
										isInvalid={error?.documentNumber}
										type="text"
										name="documentNumber"
										placeholder={t("property.documentNumberPlaceholder")}
										value={markMultiplePaymentsAsPaidInformation.documentNumber}
										onChange={handleChangeMarkMultiplePaymentsAsPaidInformation}
										borderRadius="md"
									/>
								</FormControl>
							</SimpleGrid>
							<FormControl>
								<ModalFieldLabel icon={FiCreditCard}>{t("property.method")}</ModalFieldLabel>
								<Select
									size="sm"
									onChange={handleChangeMarkMultiplePaymentsAsPaidInformation}
									name="paymentMethod"
									value={markMultiplePaymentsAsPaidInformation.paymentMethod}
									borderRadius="md"
								>
									<option value="op">OP</option>
									<option value="cash">Cash</option>
									<option value="personal">Personal</option>
								</Select>
							</FormControl>
							<FormControl>
								<ModalFieldLabel icon={FiFileText}>{t("property.descriptionLabel")}</ModalFieldLabel>
								<Textarea
									size="sm"
									isInvalid={error?.description}
									name="description"
									placeholder={t("property.descriptionPlaceholder")}
									value={markMultiplePaymentsAsPaidInformation.description}
									onChange={handleChangeMarkMultiplePaymentsAsPaidInformation}
									rows={3}
									borderRadius="md"
								/>
							</FormControl>
						</VStack>
					</PropertyModalSection>

					<PropertyModalSection icon={FiUpload} title={t("property.supportingDocuments")}>
						<Dropzone
							onDrop={onDocumentDrop}
							accept={{
								"application/pdf": [".pdf"],
								"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
								"application/msword": [".doc"],
							}}
							description={t("property.uploadPdfDocDocx")}
							maxFiles={1}
						/>
					</PropertyModalSection>
				</VStack>

				<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
					<PropertyModalSection icon={FiUser} title={t("property.billingInformation")}>
						<VStack spacing={3} align="stretch">
							<FormControl>
								<ModalFieldLabel icon={FiUser}>{t("property.billedTo")}</ModalFieldLabel>
								<Select size="sm" onChange={handleBilledToChange} name="billedTo" placeholder={t("property.billedTo")} borderRadius="md">
									<option value={property.owner.email}>{property.owner.name}</option>
									{property.tenants?.map((c, index) => (
										<option key={index} value={c.email}>
											{c.name}
										</option>
									))}
									{property.contacts?.map((c, index) => (
										<option key={index} value={c.email}>
											{c.name}
										</option>
									))}
									{property.leaseContacts?.map((c, index) => (
										<option key={index} value={c.id}>
											{c.name}
										</option>
									))}
								</Select>
							</FormControl>
							<SimpleGrid columns={2} spacing={4} w="full">
								<FormControl>
									<ModalFieldLabel icon={FiUser}>{t("property.name")}</ModalFieldLabel>
									<Input
										size="sm"
										isInvalid={error?.billedToName}
										type="text"
										name="name"
										placeholder={t("property.namePlaceholder")}
										value={markMultiplePaymentsAsPaidInformation.billedTo.name}
										onChange={(e) => {
											setMarkMultiplePaymentsAsPaidInformation({
												...markMultiplePaymentsAsPaidInformation,
												billedTo: { ...markMultiplePaymentsAsPaidInformation.billedTo, name: e.target.value },
											});
										}}
										borderRadius="md"
									/>
								</FormControl>
								<FormControl>
									<ModalFieldLabel icon={FiFileText}>{t("property.type")}</ModalFieldLabel>
									<Input
										size="sm"
										isInvalid={error?.billedToType}
										type="text"
										name="type"
										placeholder={t("property.type")}
										value={markMultiplePaymentsAsPaidInformation.billedTo.type}
										onChange={(e) => {
											setMarkMultiplePaymentsAsPaidInformation({
												...markMultiplePaymentsAsPaidInformation,
												billedTo: { ...markMultiplePaymentsAsPaidInformation.billedTo, type: e.target.value },
											});
										}}
										borderRadius="md"
									/>
								</FormControl>
							</SimpleGrid>
						</VStack>
					</PropertyModalSection>

					<PropertyModalSection icon={FiInfo} title={t("property.selectPayments")}>
						<VStack spacing={3} align="stretch">
							{utilityPayments
								.filter((p) => !p.paymentDate)
								.map((payment, index) => {
									const paymentStatus = getPaymentStatus({ paymentDate: payment.paymentDate, dueDate: payment.dueDate });
									const isSelected = markMultiplePaymentsAsPaidInformation.payments.some((item) => item === payment.id);

									return (
										<Box
											key={index}
											border="2px"
											borderColor={isSelected ? "blue.200" : "gray.200"}
											borderRadius="lg"
											p={3}
											cursor="pointer"
											onClick={() => handleMarkMultiplePaymentsAsPaidChange({ target: { value: payment.id, checked: !isSelected } })}
											transition="all 0.2s"
											_hover={{ borderColor: "blue.300", bg: "blue.50" }}
											bg={isSelected ? "blue.50" : "transparent"}
										>
											<HStack spacing={3} align="start">
												<Checkbox
													name={payment.id}
													onChange={handleMarkMultiplePaymentsAsPaidChange}
													value={payment.id}
													isChecked={isSelected}
													colorScheme="blue"
													mt={1}
												/>
												<VStack align="start" spacing={1} flex={1}>
													<HStack spacing={3} justify="space-between" w="full">
														<HStack spacing={2}>
															<Icon
																as={
																	payment.type.includes("electricity")
																		? FiZap
																		: payment.type.includes("water")
																		? LuDroplets
																		: payment.type.includes("gas")
																		? FiThermometer
																		: FiFileText
																}
																color={
																	payment.type.includes("electricity")
																		? "yellow.500"
																		: payment.type.includes("water")
																		? "blue.500"
																		: payment.type.includes("gas")
																		? "orange.500"
																		: "gray.500"
																}
																boxSize={5}
															/>
															<Text fontWeight="medium" fontSize="sm">
																{t(`types.${payment.type}`)}
															</Text>
														</HStack>
														<Badge colorScheme={getPaymentStatusColor(paymentStatus)} fontSize="xs">
															{paymentStatus}
														</Badge>
													</HStack>
													<HStack spacing={4} fontSize="sm" color="gray.600">
														<HStack spacing={1}>
															<Icon as={FiHash} boxSize={3} />
															<Text>
																{payment.amount} {payment.currency}
															</Text>
														</HStack>
														<HStack spacing={1}>
															<Icon as={FiCalendar} boxSize={3} />
															<Text>
																{t("table.due")}: {moment(payment.dueDate).format(fullDateFormat)}
															</Text>
														</HStack>
													</HStack>
												</VStack>
											</HStack>
										</Box>
									);
								})}
							{error?.payments && (
								<Text color="red.500" fontSize="sm">
									{error.payments}
								</Text>
							)}
						</VStack>
					</PropertyModalSection>
				</VStack>
			</SimpleGrid>
		</PropertyModalShell>
	);
	const requestMeterPicture = () => {
		const payload = { meters: requestMeterPictureInformation, propertyId: property.id };
		console.log(payload);

		dispatch(requestMeterPictureAsync(payload))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else
					toast({
						title: "Request sent.",
						description: "Request sent.",
						status: "info",
						duration: 2000,
						isClosable: true,
					});
			})
			.finally(() => {
				onRequestMeterClose();
				setRequestMeterPictureInformation(initialRequestMeterPictureInformation);
			});
	};
	const onInvoiceDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const name = acceptedFiles[0].name;
		const contentType = acceptedFiles[0].type;
		const invoice = { invoiceData: _arrayBufferToBase64(buffer), documentName: name, contentType };
		setUtilityInvoiceInformation({ ...utilityInvoiceInformation, invoice });
	};

	const handleUtilityMeterChange = (e) => {
		setMeterInformation({ ...meterInformation, [e.target.name]: e.target.value });
	};
	const handleEditMeterChange = (e) => {
		setEditMeterInformation({ ...editMeterInformation, meter: { ...editMeterInformation.meter, [e.target.name]: e.target.value } });
	};
	const handleEditMeterRequestPeriodChange = (e) => {
		setEditMeterInformation({
			...editMeterInformation,
			meter: { ...editMeterInformation.meter, requestPeriod: { ...editMeterInformation.meter.requestPeriod, [e.target.name]: e.target.value } },
		});
	};
	const handleUtilityInvoiceChange = (e) => {
		console.log(e.target.value);
		setUtilityInvoiceInformation({ ...utilityInvoiceInformation, [e.target.name]: e.target.value });
	};
	const handleCloseInvoiceModal = () => {
		onInvoiceClose();
		setError({});
	};
	const renderAddUtilityInvoiceModal = () => (
		<PropertyModalShell
			isOpen={isInvoiceOpen}
			onClose={handleCloseInvoiceModal}
			size="4xl"
			icon={IoReceiptOutline}
			title={t("property.addUtilityInvoice")}
			subtitle={t("property.addUtilityInvoiceSubtitle")}
			footer={
				<ModalFooterActions
					isLoading={loading}
					isDisabled={loading}
					onCancel={handleCloseInvoiceModal}
					onConfirm={addUtilityInvoice}
					confirmLabel={t("misc.save")}
				/>
			}
		>
			<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
				<Alert status="info" borderRadius="md" size="sm">
					<AlertIcon />
					<VStack align="start" spacing={1}>
						<AlertTitle fontSize="sm">{t("property.utilityInvoiceAlertTitle")}</AlertTitle>
						<AlertDescription fontSize="sm">{t("property.utilityInvoiceAlertDescription")}</AlertDescription>
					</VStack>
				</Alert>

				<PropertyModalSection icon={FiInfo} title={t("property.invoiceDetails")}>
					<VStack spacing={3} align="stretch">
						<SimpleGrid columns={2} spacing={4} w="full">
							<FormControl>
								<ModalFieldLabel icon={FiSettings}>{t("property.utilityType")}</ModalFieldLabel>
								<Select
									size="sm"
									onChange={handleUtilityInvoiceChange}
									name="utilityType"
									placeholder={t("property.selectUtilityType")}
									isInvalid={error?.utilityType}
									value={utilityInvoiceInformation.utilityType}
									borderRadius="md"
								>
									<option value="electricity">{t("property.electricity")}</option>
									<option value="gas">{t("property.gas")}</option>
									<option value="water">{t("property.water")}</option>
									<option value="sanitation">{t("property.sanitation")}</option>
									<option value="internet">{t("property.internet")}</option>
									<option value="cleaning">{t("property.cleaning")}</option>
								</Select>
							</FormControl>
							<FormControl>
								<ModalFieldLabel icon={FiCalendar}>{t("table.dueDate")}</ModalFieldLabel>
								<Input
									size="sm"
									onChange={handleUtilityInvoiceChange}
									type="date"
									name="dueDate"
									isInvalid={error?.dueDate}
									value={utilityInvoiceInformation.dueDate}
									borderRadius="md"
								/>
							</FormControl>
						</SimpleGrid>
						<SimpleGrid columns={2} spacing={4} w="full">
							<FormControl>
								<ModalFieldLabel icon={FiHash}>{t("property.amount")}</ModalFieldLabel>
								<Input
									size="sm"
									onChange={handleUtilityInvoiceChange}
									type="number"
									name="amount"
									isInvalid={error?.amount}
									value={utilityInvoiceInformation.amount}
									placeholder={t("property.amountPlaceholder")}
									borderRadius="md"
								/>
							</FormControl>
							<FormControl>
								<ModalFieldLabel icon={FiGlobe}>{t("property.currency")}</ModalFieldLabel>
								<Select
									size="sm"
									onChange={handleUtilityInvoiceChange}
									value={utilityInvoiceInformation.currency}
									name="currency"
									isInvalid={error?.currency}
									borderRadius="md"
								>
									<option value="eur">EUR</option>
									<option value="ron">RON</option>
								</Select>
							</FormControl>
						</SimpleGrid>
					</VStack>
				</PropertyModalSection>

				<PropertyModalSection icon={FiUpload} title={t("property.invoiceDocument")}>
					<Dropzone
						onDrop={onInvoiceDrop}
						accept={{
							"application/pdf": [".pdf"],
							"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
							"application/msword": [".doc"],
						}}
						description={t("property.uploadPdfDocDocx")}
						maxFiles={1}
					/>
				</PropertyModalSection>
			</VStack>
		</PropertyModalShell>
	);
	const renderUtilityHistoryTable = (utility) => {
		return (
			<Table variant="simple">
				<Thead>
					<Tr my=".8rem">
						<Th>Index</Th>
						<Th>Date</Th>
						<Th></Th>
					</Tr>
				</Thead>
				<Tbody>
					{utility.map((u, index) => (
						<UtilityMeterTableRow
							key={index}
							meterIndex={u.meterIndex}
							timestamp={u.timestamp}
							isCurrent={index === 0}
							additionalMeterIndex={u.additionalMeterIndex}
						/>
					))}
				</Tbody>
			</Table>
		);
	};
	const renderUtilityPictureHistory = () => {
		return (
			<Stack>
				{images.length === 0 && <Text>{t("property.noMeterPicturesYet")}</Text>}
				<Wrap>
					{images.map((i, index) => (
						<WrapItem key={index}>
							<Box position="relative" key={index}>
								<Image
									src={i.url}
									onClick={() => openImageViewer(index)}
									height={"200px"}
									style={{ margin: "2px" }}
									alt="meter index picture"
									cursor={"pointer"}
									className="ticketDocument"
								/>
								<Text className="ticketDocumentDownloadButton" style={{ position: "absolute", top: "5%", left: "5%", display: "none" }} fontWeight={"bold"}>
									{moment(i.addedDate).format("DD MMM YYYY - HH:mm")}
								</Text>
							</Box>
						</WrapItem>
					))}

					{isViewerOpen && (
						<ImageViewer
							src={images.map((i) => i.url)}
							currentIndex={currentImage}
							onClose={closeImageViewer}
							disableScroll={false}
							backgroundStyle={{
								backgroundColor: "rgba(0,0,0,0.9)",
							}}
							closeOnClickOutside={true}
						/>
					)}
				</Wrap>
			</Stack>
		);
	};
	const renderUtilityMeterHistoryModal = () => (
		<PropertyModalShell
			isOpen={isHistoryOpen}
			onClose={onHistoryClose}
			size="5xl"
			icon={TbHistory}
			title={t("property.history")}
			subtitle={t("property.historySubtitle")}
			footer={<ModalFooterActions onCancel={onHistoryClose} cancelLabel={t("misc.close")} />}
		>
			<Tabs variant="soft-rounded" colorScheme="blue" size="sm">
				<TabList mb={4}>
					<Tab>
						<HStack spacing={2}>
							<Icon as={FiThermometer} />
							<Text>{t("property.gas")}</Text>
						</HStack>
					</Tab>
					<Tab>
						<HStack spacing={2}>
							<Icon as={FiZap} />
							<Text>{t("property.electricity")}</Text>
						</HStack>
					</Tab>
					<Tab>
						<HStack spacing={2}>
							<Icon as={LuDroplets} />
							<Text>{t("property.water")}</Text>
						</HStack>
					</Tab>
					<Tab>
						<HStack spacing={2}>
							<Icon as={FiCamera} />
							<Text>{t("types.meterPictures")}</Text>
						</HStack>
					</Tab>
				</TabList>
				<TabPanels>
					<TabPanel p={0}>
						<PropertyModalSection icon={FiThermometer} title={t("property.gasMeterHistory")}>
							{renderUtilityHistoryTable([...property.utilities.gas.indexes].sort((a, b) => moment(b.timestamp).unix() - moment(a.timestamp).unix()))}
						</PropertyModalSection>
					</TabPanel>
					<TabPanel p={0}>
						<PropertyModalSection icon={FiZap} title={t("property.electricityMeterHistory")}>
							{renderUtilityHistoryTable(
								[...property.utilities.electricity.indexes].sort((a, b) => moment(b.timestamp).unix() - moment(a.timestamp).unix())
							)}
						</PropertyModalSection>
					</TabPanel>
					<TabPanel p={0}>
						<PropertyModalSection icon={LuDroplets} title={t("property.waterMeterHistory")}>
							{renderUtilityHistoryTable([...property.utilities.water.indexes].sort((a, b) => moment(b.timestamp).unix() - moment(a.timestamp).unix()))}
						</PropertyModalSection>
					</TabPanel>
					<TabPanel p={0}>
						<PropertyModalSection icon={FiCamera} title={t("types.meterPictures")}>
							{renderUtilityPictureHistory(property.utilities.meterPictureHistory)}
						</PropertyModalSection>
					</TabPanel>
				</TabPanels>
			</Tabs>
		</PropertyModalShell>
	);
	const renderRequestMeterPictureModal = () => (
		<PropertyModalShell
			isOpen={isRequestMeterOpen}
			onClose={onRequestMeterClose}
			size="4xl"
			icon={FiCamera}
			title={t("property.requestMeterPicture")}
			subtitle={t("property.requestMeterPictureSubtitle")}
			footer={
				<ModalFooterActions
					onCancel={onRequestMeterClose}
					onConfirm={requestMeterPicture}
					confirmLabel={t("misc.request")}
				/>
			}
		>
			<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
				<Alert status="info" borderRadius="md" size="sm">
					<AlertIcon />
					<VStack align="start" spacing={1}>
						<AlertTitle fontSize="sm">{t("property.meterPictureRequestTitle")}</AlertTitle>
						<AlertDescription fontSize="sm">{t("property.meterPictureRequestDescription")}</AlertDescription>
					</VStack>
				</Alert>

				<PropertyModalSection icon={FiSettings} title={t("property.selectMeters")}>
					<SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
						<Box
							border="2px"
							borderColor={requestMeterPictureInformation.water ? "blue.200" : "gray.200"}
							borderRadius="lg"
							p={4}
							cursor="pointer"
							onClick={() => handleRequestMeterPictureChange({ target: { name: "water", checked: !requestMeterPictureInformation.water } })}
							transition="all 0.2s"
							_hover={{ borderColor: "blue.300", bg: "blue.50" }}
							bg={requestMeterPictureInformation.water ? "blue.50" : "transparent"}
						>
							<Checkbox
								name="water"
								onChange={handleRequestMeterPictureChange}
								colorScheme="blue"
								isChecked={requestMeterPictureInformation.water}
								mb={3}
							/>
							<VStack spacing={2} align="center">
								<Icon as={LuDroplets} color="blue.500" boxSize={8} />
								<Text fontSize="md" fontWeight="medium" textAlign="center">
									{t("property.waterMeter")}
								</Text>
								<Text fontSize="sm" color="gray.600" textAlign="center">
									{t("property.requestWaterMeterReading")}
								</Text>
							</VStack>
						</Box>

						<Box
							border="2px"
							borderColor={requestMeterPictureInformation.electricity ? "yellow.200" : "gray.200"}
							borderRadius="lg"
							p={4}
							cursor="pointer"
							onClick={() => handleRequestMeterPictureChange({ target: { name: "electricity", checked: !requestMeterPictureInformation.electricity } })}
							transition="all 0.2s"
							_hover={{ borderColor: "yellow.300", bg: "yellow.50" }}
							bg={requestMeterPictureInformation.electricity ? "yellow.50" : "transparent"}
						>
							<Checkbox
								name="electricity"
								onChange={handleRequestMeterPictureChange}
								colorScheme="yellow"
								isChecked={requestMeterPictureInformation.electricity}
								mb={3}
							/>
							<VStack spacing={2} align="center">
								<Icon as={FiZap} color="yellow.500" boxSize={8} />
								<Text fontSize="md" fontWeight="medium" textAlign="center">
									{t("property.electricityMeter")}
								</Text>
								<Text fontSize="sm" color="gray.600" textAlign="center">
									{t("property.requestElectricityMeterReading")}
								</Text>
							</VStack>
						</Box>

						<Box
							border="2px"
							borderColor={requestMeterPictureInformation.gas ? "orange.200" : "gray.200"}
							borderRadius="lg"
							p={4}
							cursor="pointer"
							onClick={() => handleRequestMeterPictureChange({ target: { name: "gas", checked: !requestMeterPictureInformation.gas } })}
							transition="all 0.2s"
							_hover={{ borderColor: "orange.300", bg: "orange.50" }}
							bg={requestMeterPictureInformation.gas ? "orange.50" : "transparent"}
						>
							<Checkbox
								name="gas"
								onChange={handleRequestMeterPictureChange}
								colorScheme="orange"
								isChecked={requestMeterPictureInformation.gas}
								mb={3}
							/>
							<VStack spacing={2} align="center">
								<Icon as={FiThermometer} color="orange.500" boxSize={8} />
								<Text fontSize="md" fontWeight="medium" textAlign="center">
									{t("property.gasMeter")}
								</Text>
								<Text fontSize="sm" color="gray.600" textAlign="center">
									{t("property.requestGasMeterReading")}
								</Text>
							</VStack>
						</Box>
					</SimpleGrid>
				</PropertyModalSection>
			</VStack>
		</PropertyModalShell>
	);
	const handleCloseMeterModal = () => {
		onMeterClose();
		setError({});
	};
	const renderAddUtilityMeterModal = () => (
		<PropertyModalShell
			isOpen={isMeterOpen}
			onClose={handleCloseMeterModal}
			size="3xl"
			icon={FiSettings}
			title={t("property.addIndex")}
			subtitle={t("property.addIndexSubtitle")}
			footer={
				<ModalFooterActions
					isLoading={loading}
					isDisabled={loading}
					onCancel={handleCloseMeterModal}
					onConfirm={addUtilityMeter}
					confirmLabel={t("misc.save")}
				/>
			}
		>
			<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
				<Alert status="info" borderRadius="md" size="sm">
					<AlertIcon />
					<VStack align="start" spacing={1}>
						<AlertTitle fontSize="sm">{t("property.meterReadingTitle")}</AlertTitle>
						<AlertDescription fontSize="sm">{t("property.meterReadingDescription")}</AlertDescription>
					</VStack>
				</Alert>

				<PropertyModalSection icon={FiInfo} title={t("property.meterInformation")}>
					<VStack spacing={3} align="stretch">
						<SimpleGrid columns={2} spacing={4} w="full">
							<FormControl>
								<ModalFieldLabel icon={FiSettings}>{t("property.meterType")}</ModalFieldLabel>
								<Select
									size="sm"
									name="meterType"
									isInvalid={error?.meterType}
									value={meterInformation.meterType}
									onChange={handleUtilityMeterChange}
									placeholder={t("property.selectMeterType")}
									borderRadius="md"
								>
									<option value="electricity">{t("property.electricity")}</option>
									<option value="gas">{t("property.gas")}</option>
									<option value="water">{t("property.water")}</option>
								</Select>
							</FormControl>
							<FormControl>
								<ModalFieldLabel icon={FiZap}>{t("property.newIndex")}</ModalFieldLabel>
								<Input
									size="sm"
									type="number"
									name="meterIndex"
									onChange={handleUtilityMeterChange}
									isInvalid={error?.meterIndex}
									value={meterInformation.meterIndex}
									placeholder={t("property.enterIndexValue")}
									borderRadius="md"
								/>
							</FormControl>
						</SimpleGrid>
						{meterInformation.meterType === "water" && (
							<FormControl>
								<ModalFieldLabel icon={LuDroplets}>{t("property.additionalIndexOptional")}</ModalFieldLabel>
								<Input
									size="sm"
									type="number"
									name="additionalMeterIndex"
									onChange={handleUtilityMeterChange}
									value={meterInformation.additionalMeterIndex}
									placeholder={t("property.enterAdditionalIndex")}
									borderRadius="md"
								/>
							</FormControl>
						)}
					</VStack>
				</PropertyModalSection>
			</VStack>
		</PropertyModalShell>
	);
	const handleCloseEditMeterModal = () => {
		onEditMeterClose();
		setError({});
	};
	const renderEditMeterModal = () => (
		<PropertyModalShell
			isOpen={isEditMeterOpen}
			onClose={handleCloseEditMeterModal}
			size="3xl"
			icon={FiEdit3}
			title={t("property.editMeterTitle", { type: t(`property.${editMeterInformation.meterType}`) })}
			subtitle={t("property.editMeterSubtitle")}
			footer={
				<ModalFooterActions onCancel={handleCloseEditMeterModal} onConfirm={saveMeterInformation} confirmLabel={t("misc.save")} />
			}
		>
			<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
				{editMeterInformation.meterType !== "water" && (
					<PropertyModalSection icon={FiSettings} title={t("property.meterCodes")}>
						<VStack spacing={3} align="stretch">
							{editMeterInformation.meterType === "electricity" && (
								<SimpleGrid columns={2} spacing={4} w="full">
									<FormControl>
										<ModalFieldLabel icon={FiZap}>{t("property.nlcCode")}</ModalFieldLabel>
										<Input
											size="sm"
											name="nlcCode"
											onChange={handleEditMeterChange}
											value={editMeterInformation.meter.nlcCode}
											placeholder={t("property.nlcCode")}
											borderRadius="md"
										/>
									</FormControl>
									<FormControl>
										<ModalFieldLabel icon={FiZap}>{t("property.atmCode")}</ModalFieldLabel>
										<Input
											size="sm"
											name="atmCode"
											onChange={handleEditMeterChange}
											value={editMeterInformation.meter.atmCode}
											placeholder={t("property.atmCode")}
											borderRadius="md"
										/>
									</FormControl>
								</SimpleGrid>
							)}
							{editMeterInformation.meterType === "gas" && (
								<SimpleGrid columns={2} spacing={4} w="full">
									<FormControl>
										<ModalFieldLabel icon={FiThermometer}>{t("property.paymentCode")}</ModalFieldLabel>
										<Input
											size="sm"
											name="paymentCode"
											onChange={handleEditMeterChange}
											value={editMeterInformation.meter.paymentCode}
											placeholder={t("property.paymentCode")}
											borderRadius="md"
										/>
									</FormControl>
									<FormControl>
										<ModalFieldLabel icon={FiThermometer}>{t("property.clientCode")}</ModalFieldLabel>
										<Input
											size="sm"
											name="clientCode"
											onChange={handleEditMeterChange}
											value={editMeterInformation.meter.clientCode}
											placeholder={t("property.clientCode")}
											borderRadius="md"
										/>
									</FormControl>
								</SimpleGrid>
							)}
						</VStack>
					</PropertyModalSection>
				)}

				<PropertyModalSection icon={FiCalendar} title={t("property.collectionPeriod")}>
					<VStack spacing={3} align="stretch">
						<Text fontSize="sm" color="gray.500">
							{t("property.collectionPeriodHint")}
						</Text>
						<HStack spacing={4} w="full">
							<FormControl>
								<ModalFieldLabel icon={FiCalendar}>{t("property.firstDay")}</ModalFieldLabel>
								<Input
									size="sm"
									name="firstDay"
									onChange={handleEditMeterRequestPeriodChange}
									value={editMeterInformation.meter?.requestPeriod.firstDay}
									placeholder={t("property.firstDay")}
									borderRadius="md"
								/>
							</FormControl>
							<Text as="span" alignSelf="end" mb={2}>
								-
							</Text>
							<FormControl>
								<ModalFieldLabel icon={FiCalendar}>{t("property.lastDay")}</ModalFieldLabel>
								<Input
									size="sm"
									name="lastDay"
									onChange={handleEditMeterRequestPeriodChange}
									value={editMeterInformation.meter?.requestPeriod.lastDay}
									placeholder={t("property.lastDay")}
									borderRadius="md"
								/>
							</FormControl>
						</HStack>
					</VStack>
				</PropertyModalSection>
			</VStack>
		</PropertyModalShell>
	);

	const getCurrentIndexTimestamp = (utilityType) => {
		return utilityType.indexes.length > 0
			? moment([...utilityType.indexes].sort((a, b) => moment(b.timestamp).unix() - moment(a.timestamp).unix())[0].timestamp).format(fullDateTimeFormat)
			: "Not available";
	};
	const getAdditionalIndex = (utilityType) => {
		return utilityType.indexes.length > 0
			? [...utilityType.indexes].sort((a, b) => moment(b.timestamp).unix() - moment(a.timestamp).unix())[0].additionalMeterIndex || "Not available"
			: "Not available";
	};
	const getCurrentIndex = (utilityType) => {
		return utilityType.indexes.length > 0
			? [...utilityType.indexes].sort((a, b) => moment(b.timestamp).unix() - moment(a.timestamp).unix())[0].meterIndex
			: "Not available";
	};
	const handleEditIndex = (type) => {
		onEditMeterOpen();
		console.log({ meter: property.utilities[type], type });
		setEditMeterInformation({ ...editMeterInformation, meter: property.utilities[type], meterType: type });
	};
	const getUnpaidUtilityPayments = () => {
		//get the utility payments with the status
		const utilityPayments = property.payments.filter((payment) => payment.type.toLowerCase().includes("utility"));
		console.log(utilityPayments);
		const overdue = utilityPayments.filter((payment) => getPaymentStatus({ paymentDate: payment.paymentDate, dueDate: payment.dueDate }) === "Overdue");
		const due = utilityPayments.filter((payment) => getPaymentStatus({ paymentDate: payment.paymentDate, dueDate: payment.dueDate }) === "Due");
		//calculate the total amount in eur and ron
		const overdueAmount = overdue.reduce(
			(acc, payment) => {
				if (payment.currency === "eur") return { eur: acc.eur + Number(payment.amount), ron: acc.ron };
				else return { eur: acc.eur, ron: acc.ron + Number(payment.amount) };
			},
			{ eur: 0, ron: 0 }
		);
		//calculate the total amount in eur and ron
		const dueAmount = due.reduce(
			(acc, payment) => {
				if (payment.currency === "eur") return { eur: acc.eur + Number(payment.amount), ron: acc.ron };
				else return { eur: acc.eur, ron: acc.ron + Number(payment.amount) };
			},
			{ eur: 0, ron: 0 }
		);

		return {
			overdue: overdueAmount,
			due: dueAmount,
		};
	};
	const unpaidUtilityPayments = getUnpaidUtilityPayments();
	return (
		<Stack spacing={6}>
			<Wrap>
				<WrapItem>
					<Button onClick={onMeterOpen} colorScheme="blue" isDisabled={isArchived}>
						{t("property.addIndex")}
					</Button>
				</WrapItem>
				<WrapItem>
					<Button onClick={onInvoiceOpen} colorScheme="blue" isDisabled={isArchived}>
						{t("property.addUtilityInvoice")}
					</Button>
				</WrapItem>
				<WrapItem>
					<Button onClick={onHistoryOpen} colorScheme="blackAlpha" isDisabled={isArchived}>
						{t("property.history")}
					</Button>
				</WrapItem>
				<WrapItem>
					<Tooltip label="Add tenants to enable" isDisabled={property.tenants.filter((t) => !t.former).length !== 0}>
						<Button onClick={onRequestMeterOpen} colorScheme="blackAlpha" isDisabled={isArchived}>
							{t("property.requestMeterPicture")}
						</Button>
					</Tooltip>
				</WrapItem>
			</Wrap>
			<Divider />
			<Accordion allowToggle>
				<AccordionItem border="1px" borderColor={borderColor} borderRadius="lg" overflow="hidden">
					<AccordionButton py={4} px={6} _hover={{ bg: "gray.50" }}>
						<HStack spacing={3} flex="1" textAlign="left">
							<Icon as={FiSettings} color={iconColor} boxSize={5} />
							<Text fontWeight="semibold" fontSize="md">
								Available Utilities
							</Text>
						</HStack>
						<AccordionIcon />
					</AccordionButton>
					<AccordionPanel pb={6} px={6}>
						<SimpleGrid columns={{ base: 2, md: 3, lg: 5 }} spacing={4}>
							<Box
								border="2px"
								borderColor={availableUtilitiesInformation.gas ? "orange.200" : "gray.200"}
								borderRadius="lg"
								p={4}
								cursor="pointer"
								onClick={() => handleChangeCheckboxes({ target: { name: "gas", checked: !availableUtilitiesInformation.gas } })}
								transition="all 0.2s"
								_hover={{
									borderColor: "orange.300",
									bg: "orange.50",
								}}
								bg={availableUtilitiesInformation.gas ? "orange.50" : "transparent"}
							>
								<Checkbox name="gas" isChecked={availableUtilitiesInformation.gas} onChange={handleChangeCheckboxes} colorScheme="orange" mb={3} />
								<VStack spacing={2} align="center">
									<Icon as={FiThermometer} color="orange.500" boxSize={6} />
									<Text fontSize="sm" fontWeight="medium" textAlign="center">
										{t("property.gas")}
									</Text>
								</VStack>
							</Box>

							<Box
								border="2px"
								borderColor={availableUtilitiesInformation.electricity ? "yellow.200" : "gray.200"}
								borderRadius="lg"
								p={4}
								cursor="pointer"
								onClick={() => handleChangeCheckboxes({ target: { name: "electricity", checked: !availableUtilitiesInformation.electricity } })}
								transition="all 0.2s"
								_hover={{
									borderColor: "yellow.300",
									bg: "yellow.50",
								}}
								bg={availableUtilitiesInformation.electricity ? "yellow.50" : "transparent"}
							>
								<Checkbox
									name="electricity"
									isChecked={availableUtilitiesInformation.electricity}
									onChange={handleChangeCheckboxes}
									colorScheme="yellow"
									mb={3}
								/>
								<VStack spacing={2} align="center">
									<Icon as={FiZap} color="yellow.500" boxSize={6} />
									<Text fontSize="sm" fontWeight="medium" textAlign="center">
										{t("property.electricity")}
									</Text>
								</VStack>
							</Box>

							<Box
								border="2px"
								borderColor={availableUtilitiesInformation.water ? "blue.200" : "gray.200"}
								borderRadius="lg"
								p={4}
								cursor="pointer"
								onClick={() => handleChangeCheckboxes({ target: { name: "water", checked: !availableUtilitiesInformation.water } })}
								transition="all 0.2s"
								_hover={{
									borderColor: "blue.300",
									bg: "blue.50",
								}}
								bg={availableUtilitiesInformation.water ? "blue.50" : "transparent"}
							>
								<Checkbox name="water" isChecked={availableUtilitiesInformation.water} onChange={handleChangeCheckboxes} colorScheme="blue" mb={3} />
								<VStack spacing={2} align="center">
									<Icon as={LuDroplets} color="blue.500" boxSize={6} />
									<Text fontSize="sm" fontWeight="medium" textAlign="center">
										{t("property.water")}
									</Text>
								</VStack>
							</Box>

							<Box
								border="2px"
								borderColor={availableUtilitiesInformation.sanitation ? "green.200" : "gray.200"}
								borderRadius="lg"
								p={4}
								cursor="pointer"
								onClick={() => handleChangeCheckboxes({ target: { name: "sanitation", checked: !availableUtilitiesInformation.sanitation } })}
								transition="all 0.2s"
								_hover={{
									borderColor: "green.300",
									bg: "green.50",
								}}
								bg={availableUtilitiesInformation.sanitation ? "green.50" : "transparent"}
							>
								<Checkbox name="sanitation" isChecked={availableUtilitiesInformation.sanitation} onChange={handleChangeCheckboxes} colorScheme="green" mb={3} />
								<VStack spacing={2} align="center">
									<Icon as={FiSettings} color="green.500" boxSize={6} />
									<Text fontSize="sm" fontWeight="medium" textAlign="center">
										{t("property.sanitation")}
									</Text>
								</VStack>
							</Box>

							<Box
								border="2px"
								borderColor={availableUtilitiesInformation.internet ? "purple.200" : "gray.200"}
								borderRadius="lg"
								p={4}
								cursor="pointer"
								onClick={() => handleChangeCheckboxes({ target: { name: "internet", checked: !availableUtilitiesInformation.internet } })}
								transition="all 0.2s"
								_hover={{
									borderColor: "purple.300",
									bg: "purple.50",
								}}
								bg={availableUtilitiesInformation.internet ? "purple.50" : "transparent"}
							>
								<Checkbox name="internet" isChecked={availableUtilitiesInformation.internet} onChange={handleChangeCheckboxes} colorScheme="purple" mb={3} />
								<VStack spacing={2} align="center">
									<Icon as={FiGlobe} color="purple.500" boxSize={6} />
									<Text fontSize="sm" fontWeight="medium" textAlign="center">
										{t("property.internet")}
									</Text>
								</VStack>
							</Box>
						</SimpleGrid>

						<HStack justify="center" mt={6}>
							<Button onClick={saveCheckboxes} colorScheme="blue" isDisabled={isArchived} leftIcon={<Icon as={FiCheckCircle} />} px={8}>
								{t("misc.save")}
							</Button>
						</HStack>
					</AccordionPanel>
				</AccordionItem>
			</Accordion>
			<Grid templateColumns="repeat(3, 1fr)" gap="24px">
				<GridItem colSpan={{ lg: "1", base: "6" }}>
					<Card variant={"elevated"}>
						<CardHeader fontSize="xl" pb={0}>
							<Flex justifyContent={"space-between"}>
								<Flex alignItems={"center"}>
									<Text fontWeight={"bold"}>{t("property.gasIndex")}</Text> <Icon as={FiThermometer} color="orange.400" />
								</Flex>
								<Text as="span">{getCurrentIndexTimestamp(property.utilities.gas)}</Text>
							</Flex>
						</CardHeader>
						<CardBody>
							<Stack direction={"column"}>
								<Stack direction="row">
									<Text fontWeight={"bold"}>{t("property.index")}:</Text>
									<Text>{getCurrentIndex(property.utilities.gas)}</Text>
								</Stack>
								<Stack direction="row">
									<Text>{t("property.collectionCode")}:</Text>
									<Text>{property.utilities.gas.paymentCode ? property.utilities.gas.paymentCode : "Not available"}</Text>
								</Stack>
								<Stack direction="row">
									<Text>{t("property.clientCode")}:</Text>
									<Text>{property.utilities.gas.clientCode ? property.utilities.gas.clientCode : "Not available"}</Text>
								</Stack>
								<Stack direction="row">
									<Text>{t("property.requestPeriod")}:</Text>
									<Box>{getRequestPeriodBadge(property, "gas", moment().format())}</Box>
								</Stack>
								<Flex direction="row" justifyContent={"space-between"}>
									<Tooltip label="Add index">
										<IconButton
											icon={<AddIcon />}
											colorScheme="green"
											onClick={() => {
												onMeterOpen();
												setMeterInformation({ ...meterInformation, meterType: "gas" });
											}}
											isDisabled={isArchived}
										/>
									</Tooltip>
									<IconButton
										isDisabled={isArchived}
										onClick={() => {
											handleEditIndex("gas");
										}}
									>
										<EditIcon />
									</IconButton>
								</Flex>
							</Stack>
						</CardBody>
					</Card>
				</GridItem>
				<GridItem colSpan={{ lg: "1", base: "6" }}>
					<Card variant={"elevated"}>
						<CardHeader fontSize="xl" pb={0}>
							<Flex justifyContent={"space-between"}>
								<Flex alignItems={"center"}>
									<Text fontWeight="bold">{t("property.electricityIndex")}</Text>
									<Icon as={FiZap} color="yellow.400" />
								</Flex>
								<Text as="span">{getCurrentIndexTimestamp(property.utilities.electricity)}</Text>
							</Flex>
						</CardHeader>
						<CardBody>
							<Stack direction="column">
								<Stack direction="row">
									<Text fontWeight={"bold"}>{t("property.index")}:</Text>
									<Text>{getCurrentIndex(property.utilities.electricity)}</Text>
								</Stack>
								<Stack direction="row">
									<Text>{t("property.nlcCode")}:</Text>
									<Text>{property.utilities.electricity.nlcCode ? property.utilities.electricity.nlcCode : "Not available"}</Text>
								</Stack>
								<Stack direction="row">
									<Text>{t("property.atmCode")}:</Text>
									<Text>{property.utilities.electricity.atmCode ? property.utilities.electricity.atmCode : "Not available"}</Text>
								</Stack>
								<Stack direction="row">
									<Text>{t("property.requestPeriod")}:</Text>
									<Box>{getRequestPeriodBadge(property, "electricity", moment().format())}</Box>
								</Stack>
								<Flex direction="row" justifyContent={"space-between"}>
									<Tooltip label="Add index">
										<IconButton
											icon={<AddIcon />}
											colorScheme="green"
											onClick={() => {
												onMeterOpen();
												setMeterInformation({ ...meterInformation, meterType: "electricity" });
											}}
											isDisabled={isArchived}
										/>
									</Tooltip>
									<IconButton
										onClick={() => {
											handleEditIndex("electricity");
										}}
										isDisabled={isArchived}
									>
										<EditIcon />
									</IconButton>
								</Flex>
							</Stack>
						</CardBody>
					</Card>
				</GridItem>
				<GridItem colSpan={{ lg: "1", base: "6" }}>
					<Card variant={"elevated"}>
						<CardHeader fontSize="xl" pb={0}>
							<Flex justifyContent={"space-between"}>
								<Flex alignItems={"center"}>
									<Text fontWeight="bold">{t("property.waterIndex")}</Text>
									<Icon as={LuDroplets} color="blue.300" />
								</Flex>
								<Text as="span">{getCurrentIndexTimestamp(property.utilities.water)}</Text>
							</Flex>
						</CardHeader>
						<CardBody>
							<Stack direction="column">
								<Stack direction="row">
									<Text fontWeight={"bold"}>{t("property.index")}:</Text> <Text>{getCurrentIndex(property.utilities.water)}</Text>
								</Stack>
								<Stack direction="row">
									<Text fontWeight={"bold"}>{t("property.additionalIndex")}:</Text> <Text>{getAdditionalIndex(property.utilities.water)}</Text>
								</Stack>
								<Stack direction="row">
									<Text>{t("property.requestPeriod")}:</Text>
									<Box>{getRequestPeriodBadge(property, "water", moment().format())}</Box>
								</Stack>
								<Flex direction="row" justifyContent={"space-between"}>
									<Tooltip label="Add index">
										<IconButton
											icon={<AddIcon />}
											colorScheme="green"
											onClick={() => {
												onMeterOpen();
												setMeterInformation({ ...meterInformation, meterType: "water" });
											}}
											isDisabled={isArchived}
										/>
									</Tooltip>
									<IconButton
										onClick={() => {
											handleEditIndex("water");
										}}
										isDisabled={isArchived}
									>
										<EditIcon />
									</IconButton>
								</Flex>
							</Stack>
						</CardBody>
					</Card>
				</GridItem>
			</Grid>
			<Box overflowX="auto">
				<Flex justifyContent={"space-between"}>
					<Stack direction={"row"} alignItems="center">
						<Text fontSize="xl" fontWeight="bold">
							{t("property.utilityPayments")}
						</Text>
						<Box>
							<Input type="text" placeholder="Search..." value={query} onChange={handleSearchChange} />
						</Box>
						<Button
							colorScheme="blue"
							onClick={onMarkMultiplePaymentsAsPaidOpen}
							isDisabled={utilityPayments.filter((p) => !p.paymentDate).length < 2 || isArchived}
						>
							{t("property.markMultipleAsPaid")}
						</Button>
					</Stack>
					<Stack direction="row" alignItems="center">
						<Badge display="flex" alignItems="center" textTransform={"none"} colorScheme="yellow">
							<Stack direction="row">
								<Text>{t("property.totalDue")}:</Text>
								<Text>{unpaidUtilityPayments.due.ron} ron,</Text>
								<Text>{unpaidUtilityPayments.due.eur} eur</Text>
							</Stack>
						</Badge>
						<Badge display="flex" alignItems="center" textTransform={"none"} colorScheme="red">
							<Stack direction="row">
								<Text>{t("property.totalOverdue")}:</Text>
								<Text>{unpaidUtilityPayments.overdue.ron} ron,</Text>
								<Text>{unpaidUtilityPayments.overdue.eur} eur</Text>
							</Stack>
						</Badge>
					</Stack>
				</Flex>
				<Table variant="simple" size="small">
					<Thead>
						<Tr my=".8rem" pl="0px">
							<Th pl="0px">{t("table.issuedDate")}</Th>
							<Th>{t("table.status")}</Th>
							<Th>{t("table.dueDate")}</Th>
							<Th>{t("table.amount")}</Th>
							<Th>{t("table.method")}</Th>
							<Th>{t("table.type")}</Th>
							<Th>{t("table.paidDate")}</Th>
							<Th></Th>
						</Tr>
					</Thead>
					<Tbody>
						{utilityPayments
							.filter((p) => !p.paymentDate)
							.map((row, index) => {
								return (
									<InvoicesRow
										id={row.id}
										key={index}
										date={row.issuedDate}
										address={getPropertyAddress(property)}
										paymentDate={row.paymentDate}
										code={row.number}
										amount={row.amount}
										type={row.type}
										dueDate={row.dueDate}
										logo={row.logo}
										format={row.format}
										method={row.paymentMethod}
										documents={row.documents}
										paymentDirection={row.paymentDirection}
										property={property}
										currency={row.currency}
										description={row.description}
										exchange={row.exchange}
									/>
								);
							})}
						{utilityPayments
							.filter((p) => p.paymentDate)
							.map((row, index) => {
								return (
									<InvoicesRow
										id={row.id}
										key={index}
										date={row.issuedDate}
										address={getPropertyAddress(property)}
										paymentDate={row.paymentDate}
										code={row.number}
										amount={row.amount}
										type={row.type}
										logo={row.logo}
										format={row.format}
										method={row.paymentMethod}
										documents={row.documents}
										paymentDirection={row.paymentDirection}
										property={property}
										currency={row.currency}
										description={row.description}
										exchange={row.exchange}
										dueDate={row.dueDate}
									/>
								);
							})}
					</Tbody>
				</Table>
			</Box>
			{renderAddUtilityMeterModal()}
			{renderAddUtilityInvoiceModal()}
			{renderUtilityMeterHistoryModal()}
			{renderRequestMeterPictureModal()}
			{renderEditMeterModal()}
			{markMultiplePaymentsAsPaidModal()}
		</Stack>
	);
}
